/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  QueryClient,
  QueryFunctionContext,
  QueryKey,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { businessMemoriesList } from "../funcs/businessMemoriesList.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import {
  ListBusinessMemoriesRequest,
  ListBusinessMemoriesResponse,
  ListBusinessMemoriesSecurity,
} from "../models/operations/listbusinessmemories.js";
import { unwrapAsync } from "../types/fp.js";
import { PageIterator, unwrapResultIterator } from "../types/operations.js";
import { pageIteratorToJSON } from "./_types.js";
export type ListBusinessMemoriesQueryData = ListBusinessMemoriesResponse;

export type ListBusinessMemoriesInfiniteQueryData = PageIterator<
  ListBusinessMemoriesResponse,
  { cursor: string }
>;

export type ListBusinessMemoriesPageParams = PageIterator<
  ListBusinessMemoriesResponse,
  { cursor: string }
>["~next"];

export function prefetchListBusinessMemories(
  queryClient: QueryClient,
  client$: GramCore,
  request?: ListBusinessMemoriesRequest | undefined,
  security?: ListBusinessMemoriesSecurity | undefined,
  options?: RequestOptions,
): Promise<void> {
  return queryClient.prefetchQuery({
    ...buildListBusinessMemoriesQuery(
      client$,
      request,
      security,
      options,
    ),
  });
}

export function prefetchListBusinessMemoriesInfinite(
  queryClient: QueryClient,
  client$: GramCore,
  request?: ListBusinessMemoriesRequest | undefined,
  security?: ListBusinessMemoriesSecurity | undefined,
  options?: RequestOptions,
): Promise<void> {
  return queryClient.prefetchInfiniteQuery({
    ...buildListBusinessMemoriesInfiniteQuery(
      client$,
      request,
      security,
      options,
    ),
    initialPageParam: undefined as ListBusinessMemoriesPageParams,
    getNextPageParam: (previousPage: ListBusinessMemoriesInfiniteQueryData) =>
      previousPage["~next"],
  });
}

export function buildListBusinessMemoriesQuery(
  client$: GramCore,
  request?: ListBusinessMemoriesRequest | undefined,
  security?: ListBusinessMemoriesSecurity | undefined,
  options?: RequestOptions,
): {
  queryKey: QueryKey;
  queryFn: (
    context: QueryFunctionContext,
  ) => Promise<ListBusinessMemoriesQueryData>;
} {
  return {
    queryKey: queryKeyListBusinessMemories({
      cursor: request?.cursor,
      contentScope: request?.contentScope,
      contentScopeNamespace: request?.contentScopeNamespace,
      limit: request?.limit,
      gramSession: request?.gramSession,
      gramProject: request?.gramProject,
    }),
    queryFn: async function listBusinessMemoriesQueryFn(
      ctx,
    ): Promise<ListBusinessMemoriesQueryData> {
      const sig = combineSignals(
        ctx.signal,
        options?.signal,
        options?.fetchOptions?.signal,
      );
      const mergedOptions = {
        ...options?.fetchOptions,
        ...options,
        signal: sig,
      };

      return unwrapAsync(businessMemoriesList(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}

export function buildListBusinessMemoriesInfiniteQuery(
  client$: GramCore,
  request?: ListBusinessMemoriesRequest | undefined,
  security?: ListBusinessMemoriesSecurity | undefined,
  options?: RequestOptions,
): {
  queryKey: QueryKey;
  queryFn: (
    context: QueryFunctionContext<QueryKey, ListBusinessMemoriesPageParams>,
  ) => Promise<ListBusinessMemoriesInfiniteQueryData>;
} {
  return {
    queryKey: queryKeyListBusinessMemoriesInfinite({
      cursor: request?.cursor,
      contentScope: request?.contentScope,
      contentScopeNamespace: request?.contentScopeNamespace,
      limit: request?.limit,
      gramSession: request?.gramSession,
      gramProject: request?.gramProject,
    }),
    queryFn: async function listBusinessMemoriesQuery(
      ctx,
    ): Promise<ListBusinessMemoriesInfiniteQueryData> {
      const sig = combineSignals(ctx.signal, options?.fetchOptions?.signal);
      const mergedOptions = {
        ...options,
        fetchOptions: { ...options?.fetchOptions, signal: sig },
      };

      if (!ctx.pageParam) {
        const pageResult = await unwrapResultIterator(businessMemoriesList(
          client$,
          request,
          security,
          mergedOptions,
        ));
        return pageIteratorToJSON(pageResult);
      }
      const pageResult = await unwrapResultIterator(businessMemoriesList(
        client$,
        {
          ...request!,
          cursor: ctx.pageParam.cursor,
        },
        security,
        mergedOptions,
      ));
      return pageIteratorToJSON(pageResult);
    },
  };
}

export function queryKeyListBusinessMemories(
  parameters: {
    cursor?: string | undefined;
    contentScope?: string | undefined;
    contentScopeNamespace?: string | undefined;
    limit?: number | undefined;
    gramSession?: string | undefined;
    gramProject?: string | undefined;
  },
): QueryKey {
  return ["@gram/client", "businessMemories", "list", parameters];
}

export function queryKeyListBusinessMemoriesInfinite(
  parameters: {
    cursor?: string | undefined;
    contentScope?: string | undefined;
    contentScopeNamespace?: string | undefined;
    limit?: number | undefined;
    gramSession?: string | undefined;
    gramProject?: string | undefined;
  },
): QueryKey {
  return ["@gram/client", "businessMemories", "list", "infinite", parameters];
}
